import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/payments-checkout/payments-checkout/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
